export default class Notification  {
  loadNotifications ($store, buildingId) {
    return $store.dispatch(
      'apiResult',
      {
        method: 'GET',
        path: `api/user-buildings/${buildingId}/available-notifications`,
        path_template: `/api/user-buildings/{building_id}/available-notifications`,
        building_id: buildingId
      }
    );
  }

  loadUserNotifications ($store, buildingId) {
    return $store.dispatch(
      'apiResult',
      {
        method: 'GET',
        path: `api/user-buildings/${buildingId}/notification`,
        path_template: `/api/user-buildings/{building_id}/notification`,
        building_id: buildingId
      }
    );
  }

  updateUserNotifications ($store, method, buildingId, notificationId) {
    return $store.dispatch(
      'apiResult',
      {
        method: method,
        path: `api/user-buildings/${buildingId}/notification/${notificationId}`,
        path_template: `/api/user-buildings/{building_id}/notification/{notification_id}`,
        building_id: buildingId
      }
    );
  }
}